/**
 * Copyright (c) 2026, CYBRA Corp. All rights reserved.
 */
export const METERS_TO_FEET_MULTIPLIER = 3.28084;
export const FEET_TO_METERS_MULTIPLIER = 0.3048;


export const EVENT_TYPE_Asset = 'Asset';
export const EVENT_TYPE_Person = 'Person';
export const EVENT_NAME_AssetEnteredLocation = 'Asset Entered Location';
export const EVENT_NAME_AssetExitedLocation = 'Asset Exited Location';
export const EVENT_NAME_AssetEnteredZone = 'Asset Entered Zone';
export const EVENT_NAME_AssetExitedZone = 'Asset Exited Zone';
export const EVENT_NAME_AssetMovement = 'Asset Movement';
export const EVENT_NAME_PersonEnteredLocation = 'Person Entered Location';
export const EVENT_NAME_PersonExitedLocation = 'Person Exited Location';
export const EVENT_NAME_PersonEnteredZone = 'Person Entered Zone';
export const EVENT_NAME_PersonExitedZone = 'Person Exited Zone';
export const EVENT_NAME_PersonMovement = 'Person Movement';

export const EVENT_PROP_Asset = 'asset';
export const EVENT_PROP_Person = 'person';



// Revisit - Need to discuss the count of result per page
export const RESULTS_PER_PAGE = [10, 25, 50, 100];

export const PAGING_ITEMS_PER_PAGE = RESULTS_PER_PAGE[0];

export const SERVEROBJECTNAME_EdgefintyServer = "Edgefinity Server";

/*
 * Constants for the default Icons / Images
 */
export const DEFAULT_USER_IMAGE = 'assets/images/userDefault.png';
export const DEFAULT_NO_IMAGE = 'assets/images/no_photo2.png';
export const DEFAULT_ANTENNA_ICON = 'assets/images/antenna_30x30.png';
export const DEFAULT_READER_ICON = 'assets/images/reader_30x30.png';
export const DEFAULT_TRACKING_ICON = 'assets/images/redcircle.png';

export const INFRA_DUMMY_FUNCTION = [{
    "id": -1,
    "name": "No Function Available",
}];
